import axios from 'axios';

// const baseURL = 'http://localhost:1311/api/';
// const baseURL = 'http://vc.asktek.net/ASK_WEB_ADMIN_PANEL_API/api/';
// const baseURL = 'http://targettest.asktek.net/asktek.dashboard.webapi/api';

// LIVE
const baseURL = 'https://live.asktek.net/asktek.net_website_manager_api/api/';

const instance = axios.create({
  headers:{
    Authorization:"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  },
  baseURL,
});

export default {
  instance,
  baseURL,
};
